import { EXPRESS_DESIGNER_SEGMENT } from '../constants';
import type { ExpressDesignerCartStorage } from '../types';
import { writeExpressDesignerSegment } from './writeExpressDesignerSegment';

export function writeExpressDesignerCartStorage(cart: ExpressDesignerCartStorage): void {
  writeExpressDesignerSegment(EXPRESS_DESIGNER_SEGMENT.Cart, cart);
}
